import { Action, Dispatch } from "redux";
import API from "../../api";
import { UpdateProductListAction, isProductRequestProcessing, productSignalController } from "../product/action";

export interface SetAutoValidTicketId extends Action {
    type: "AUTO_VALID_TICKETID";
    ticketId: string;
}
export interface AutoValidTicketUpdate extends Action {
    type: "AUTO_VALID_TICKET_UPDATE";
    status: "ENDED" | "NOTREADY";
}
export const CreateTicketAutoValid = (vin: string, orderType: AssignmentType, debitorNo: string, firstRegistrationDate?: string) => async (dispatch: Dispatch<any>) => {
    if (isProductRequestProcessing) {
        productSignalController.abort();
    }
    const result = await API.AutoValidVinSearch.CreateTicketAutoValid(vin, orderType, debitorNo, firstRegistrationDate);
    if (typeof result === 'number') {
        dispatch({ type: "AUTO_VALID_TICKETID", ticketId: result });
    }
    else {
        dispatch({ type: "AUTO_VALID_TICKET_UPDATE", status: "ENDED" });
        console.log("result", result);
        result.forEach(p => {
            p.checked = true;
            p.items.forEach(i => (i.amount = 1));
        });
        dispatch({ type: "UPDATE_PRODUCT_LIST", productGroups: result, merge: false } as UpdateProductListAction);
        setTimeout(() => {
            dispatch({ type: "AUTO_VALID_TICKET_UPDATE", status: undefined });
        }, 5000);

    }
};

let vinNumber: string | undefined = undefined

export const setVinNumber = (vin: string) => {
    vinNumber = vin;
}

export const GetTicketUpdate = (ticketId: string, orderType: AssignmentType, vin: string, debitorNo: string, firstRegistrationDate?: string) => async (dispatch: Dispatch<any>) => {
    if (vinNumber === vin) {
        setTimeout(async () => {
            const result = await API.AutoValidVinSearch.GetTicketUpdate(ticketId, orderType, debitorNo, firstRegistrationDate);
            if (typeof result === 'string') {
                dispatch({ type: "AUTO_VALID_TICKET_UPDATE", status: "NOTREADY" });
                dispatch(GetTicketUpdate(ticketId, orderType, vin, debitorNo, firstRegistrationDate));
            }
            else {
                console.log("result", result);
                dispatch({ type: "AUTO_VALID_TICKET_UPDATE", status: "ENDED" });
                if (vin === result.vin) {
                    result.products.forEach(p => {
                        p.checked = true;
                        p.items.forEach(i => (i.amount = 1));
                    });
                    dispatch({ type: "UPDATE_PRODUCT_LIST", productGroups: result.products, merge: false } as UpdateProductListAction);
                }
                setTimeout(() => {
                    dispatch({ type: "AUTO_VALID_TICKET_UPDATE", status: undefined });
                }, 5000);
            }

        }, 5000);

    }
    else {
        dispatch({ type: "AUTO_VALID_TICKET_UPDATE", status: undefined });
    }

};